<template>
  <div class="modal right fade trader-info c-offer-modal" id="trader-info" tabindex="-1" role="dialog"
    aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">TODAY'S BIDS {{ bidwanted.cusip }}</h5>
          <div class="float-right">
            <button type="button" class="close" @click="$emit('close')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
         
        </div>
        <div class="modal-body">
          <div class="row xsOnly">
            <TodayBid v-bind:cusip="bidwanted"/>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TodayBid from "../common/TodaysBid";
export default {
  name: 'sendBidModal',
  components: {
    TodayBid
  },
  props: ["bidwanted"],
  data() {
    return {
    
    };
  },
  methods: {

  },
  mounted() {
    
  }
};
</script>